export default "__VITE_ASSET__e8233b8a__"